// @file: src/actions/auth-context.js
import { createContext, useState } from "react";

import PropTypes from "prop-types";

export const AuthContext = createContext({});

const AuthProvider = ({ children }) => {
  const [isLoading, setLoading] = useState(false);

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated: false,
        isLoading,
        setLoading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthProvider;
